
<section :class="['card-profile-details', { full: page }]">
  <card-profile-images :card="card" :page="page" />

  <card-profile-stats
    :card="card"
    :card-id="cardId"
    :is-admin="isAdmin"
    :is-public="isPublic"
    :is-staff="isStaff"
    :page="page"
  />
</section>
